
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ButtonModule } from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ProjectSecretService } from '../../../../../../../shared/services/project-secret.service';

@Component({
  selector: 'app-secret-edit-modal',
  imports: [
    FormsModule,
    InputText,
    ToggleSwitchModule,
    ButtonModule
],
  templateUrl: './secret-edit-modal.component.html',
  styleUrl: './secret-edit-modal.component.scss'
})
export class SecretEditModalComponent {

  public name: string = '';
  public description: string = '';
  public secret: string = '';
  public secretId: string = "";
  public secretShouldBeUpdated: boolean = false;


  constructor(
    private bsModalRef: BsModalRef,
    protected secretService: ProjectSecretService) {
  }

  protected cancel() {
    this.name = this.description = '';
    this.bsModalRef.hide();
  }

  public secretUpdateSelectChanged() {
    this.secret = "";
  }

  protected async update() {
    if (this.secretShouldBeUpdated) {
      await this.secretService.updateSecret(this.secretId, this.name.trim(), this.description, this.secret);
    } else {
      await this.secretService.updateSecret(this.secretId, this.name.trim(), this.description);

    }
    this.cancel();
  }

  protected checkInput(): boolean {
    if (this.secretShouldBeUpdated && this.secret == "") { return true; };
    const name = this.name.trim();
    if (name === '' || this.secretService.projectSecrets.find(s => s.name == name && s._id != this.secretId) != null) return true;
    return false;
  }

}
